import * as Yup from 'yup';

export const sanitizeFileName = (input, replacement='') => {
  if (typeof input !== 'string') {
    throw new Error('Input must be string');
  }
  const spaceRe = / +/g;
  const illegalRe = /[\/\?<>\\:\*\|"]/g;
  const controlRe = /[\x00-\x1f\x80-\x9f]/g;
  const reservedRe = /^\.+$/;
  const windowsReservedRe = /^(con|prn|aux|nul|com[0-9]|lpt[0-9])(\..*)?$/i;
  const windowsTrailingRe = /[\. ]+$/;
  return input
    .replace(spaceRe, '-')
    .replace(illegalRe, replacement)
    .replace(controlRe, replacement)
    .replace(reservedRe, replacement)
    .replace(windowsReservedRe, replacement)
    .replace(windowsTrailingRe, replacement);
}


export const isFieldRequired = (schema, name) => {
  if (schema.fields[name] && schema.fields[name].tests.length && schema.fields[name].tests.some(test => test.OPTIONS && test.OPTIONS.name === 'required')) {
    return true;
  }
  return false;
}

export const apiErrorsToFormikErrors = (errors, objectName) => {
  const formikErrors = {};
  formikErrors[objectName] = {};
  errors.forEach((error) => {
    if (objectName) {
      formikErrors[objectName][error.field] = error.errorMessage;
    } else {
      formikErrors[error.field] = error.errorMessage;
    }
  });
  return formikErrors;
}

export const getErrorMessage = (errorList, fieldName) => {
  let errorMessage = '';
  const name = fieldName || 'general';
  if (errorList && errorList.length) {
    errorList.forEach((field) => {
      if (field.field === name) {
        ({ errorMessage } = field);
      }
    });
  }
  return errorMessage;
}

export const getCountryArray = (countries, field = 'countryId') => {
  if (countries && countries.length) {
    return countries.map(country => ({ label: country.countryName, value: country[field] }));
  }
  return [];
}

export const getTimezoneArray = (timezones) => {
  if (timezones && timezones.length) {
    return timezones.map(timezone => ({ label: timezone.timezoneName, value: timezone.timezoneId }));
  }
  return [];
}

export const getDayArray = () => {
  return Array(31).fill().map((day, i) => ({
    value: i > 8 ? (i + 1).toString() : `0${i + 1}`,
    label: i > 8 ? (i + 1).toString() : `0${i + 1}`
  }));
}

export const getMonthArray = () => {
  return Array(12).fill().map((month, i) => ({
    value: i > 8 ? (i + 1).toString() : `0${i + 1}`,
    label: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'][i]
  }));
}

export const getYearArray = (startYear = new Date().getFullYear(), endYear = 1910) => {
  const years = [];
  let currentYear = startYear;
  if (startYear < endYear) {
    while (currentYear <= endYear) {
      years.push({
        value: currentYear.toString(),
        label: currentYear.toString()
      });
      currentYear += 1;
    }
  } else {
    while (currentYear >= endYear) {
      years.push({
        value: currentYear.toString(),
        label: currentYear.toString()
      });
      currentYear -= 1;
    }
  }
  return years;
}


export const getReminderDayLabel = (index) => {
  if (index === -1) {
    return 'No second reminder';
  } else if (index === 0) {
    return 'On the day';
  } else if (index === 1) {
    return 'The day before';
  }
  return `${index} days before`;
}

export const getReminderDayArray = (isSecond) => {
  return Array(15).fill().map((day, i) => ({
    value: !isSecond ? i.toString() : (i - 1).toString(),
    label: getReminderDayLabel(!isSecond ? i : i - 1)
  }));
}